import { moneyStringSchema } from 'shared/components/vxl/input/schemas/moneyString.schema';
import { z } from 'zod';

export const EmploymentInfoSchema = z.object({
  employmentStatus: z
    .string({ error: 'Required' })
    .min(1, { error: 'Required' }),
  monthlyIncome: moneyStringSchema,
  tAndC: z.boolean().refine((value) => value === true),
});
